const angular = require('angular');
const app = angular.module('learn-directives');

/**
 * Defines the forgot password Directive which defines the sign in form behavior and markup
 * @argument {Passcode} Passcode injected to access the Passcode resource
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('forgotPassword', ['Users', 'Application', 'Authorization', '$translate', function (Users, Application, Authorization, $translate) {
  return {
    restrict: 'E',
    template: require('../../../templates/directives/preauth/forgot-password.html'),
    controller: function () {
      var self = this;
      self.loading = false;
      self.emailMessage = false;
      self.credentials = {email: ''};

      self.pressEnter = function(keyPress, invalid) {
        if (self.loading || invalid || keyPress !== 'click' && keyPress.which !== 13) {
          return;
        }

        if (self.credentials.email) {
          self.submitEmail();
        }
      };
      self.submitEmail = function () {
        var domain = Application.companyDomain;
        self.loading = true;
        Users.singleresetting({subresource:self.credentials.email}, {domain: domain}, function (data) {
          Application.messaging.addMessage({type: 'success', text: self.translations['preauth.forgot.emailHasBeenSent'], duration: 5});
          self.loading = false;
          self.emailMessage = true;
        }, function (error) {
          if (error && error.status === 401) {
            Application.messaging.addMessage({type: 'success', text: self.translations['preauth.forgot.emailHasBeenSent'], duration: 15});
            self.loading = false;
            return;
          }
          self.loading = false;
          Application.messaging.addMessage({type: 'success', text: self.translations['preauth.forgot.emailHasBeenSent'], duration: 5});
          if (error.status === 404) {
            Application.messaging.addMessage({type: 'information', text: self.translations['preauth.forgot.emailHasBeenSent'], duration: 15});
            return;
          }
          Authorization.clearAuthToken();
        });
      };

      $translate([
        'preauth.forgot.errorWarning',
        'preauth.forgot.emailHasBeenSent',
        'preauth.forgot.login_through_manager'
      ]).then(function(data){
        self.translations = data;
      });

    },
    controllerAs: 'forgot'
  };
}]);
